import { render, staticRenderFns } from "./askMore.vue?vue&type=template&id=533036f4&scoped=true&"
import script from "./askMore.vue?vue&type=script&lang=js&"
export * from "./askMore.vue?vue&type=script&lang=js&"
import style0 from "./askMore.vue?vue&type=style&index=0&id=533036f4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533036f4",
  null
  
)

export default component.exports